/**
* @name APP ClassPanel
* @autor pedro.rivera@dbaccess.com
* @description
* # name controller --> chatboxController
* # As Controller --> chatbox
* brief comment controller view assistance page app classPanel
*/

export default class chatboxController {
  constructor ($scope, $interval, $timeout, $cookieStore, $cookies, $location, $filter, $rootScope, chatboxServices, Messages, GlobalConfig) {

  // Variables declaradas
    $rootScope.chatNotifications = 0
    this.$rootScope = $rootScope
    this.$cookies = $cookies
    this.Messages = Messages
    this.chatboxServices = chatboxServices
    this.GlobalConfig = GlobalConfig
    this.closeContact = true
    this.minimizeContact = true
    this.id = 0
    this.showMessageBoxes = true
    this.showMessageWindow = true
    this.messageWindow = {}
    this.conversations = []
    this.messageReceive = {}
    this.messageHistory = []
    this.messageHistoryReceive = []
    this.btnSend = {'keyCode': 13}
    this.dataMessage = {}
    this.notifications = {}
    this.defaultProfileImage = require('../../../images/unknown.png')
    

    this.getCurrentTime = $interval(() => {
      this.currentTime = new Date()
    }, 1)

    this.getCurrentUser = $interval(() => {
      let cookieUser = $cookies.get('currentUser')
      if (cookieUser) {
        this.userLogin = JSON.parse(cookieUser)
        Messages.user({id: this.userLogin.id, name: this.userLogin.name})
        this.idRol = $cookies.getObject('hasRoleId')
        $timeout(() => {
            this.activate()
        }, 15000)
        $interval.cancel(this.getCurrentUser)
      }
    }, 1000)

    this.getShowChat = $interval(() => {
      this.openChatBox = $rootScope.showChat
      this.closeContact = $rootScope.openContacts
    },500)
  }// Fin del constructor

  activate () {
    this.getChatUser()
  }

  receiveData(){
    this.Messages.receive((message, isPrivate) =>{
      let i = this.chatContacts.findIndex(chat => {
        return chat.contactUserId == message.user.id
      })

      if(!this.messageWindow[message.user.id]){
        this.messageWindow[message.user.id] = {
          idUser: message.user.id, // Consulta completa de contactos
          userFullName: this.chatContacts[i].userFullName,
          onLine: this.chatContacts[i].onLine, // Debe estar integrado con la consulta del contacto
          information: [],
          showMessageWindow: false,
          delete: false,
          deleteSuccess:false,
          new: 1
        }

        this.id = message.user.id
        this.messageHistoryReceive = this.messageHistory.filter(menssages)

        if (this.messageHistoryReceive.length != 0) {
          this.messageHistoryReceive = this.messageHistoryReceive.map(objeto => {
            objeto.from = objeto.senderId != message.user.id ? this.chatContacts[i].userPicture : this.chatUser[0].userPicture
            objeto.classChat = objeto.senderId == message.user.id ? 'friend' : 'self'
            objeto.send = 1
            return objeto
          })
          this.messageWindow[message.user.id].information = this.messageHistoryReceive
        }

        this.messageReceive = ({
          'from': this.chatContacts[i].userPicture,
          'classChat': 'friend',
          'dateTime': this.currentTime,
          'dateDay':  this.checktime(this.currentTime),
          'data': message.data,
          'send': 1
        })

        this.messageWindow[message.user.id].information.push(this.messageReceive)

        this.conversations.unshift(this.messageWindow[message.user.id])
        this.countNotifications()
        return
      }

      this.messageReceive = ({
        'from': this.chatContacts[i].userPicture,
        'classChat': 'friend',
        'dateTime': this.currentTime,
        'dateDay': this.checktime(this.currentTime),
        'data': message.data,
        'send': 1
      })

      this.messageWindow[message.user.id].new = this.messageWindow[message.user.id].showMessageWindow ? 0 : 1
      this.messageWindow[message.user.id].information.push(this.messageReceive)

       this.$rootScope.showChat = true
       this.$rootScope.openContacts = true

      let indx = this.conversations.findIndex(chat => {
        return chat.idUser == message.user.id
      })

      if(indx >= 3){
        this.conversations.splice(indx, 1)
        this.conversations.unshift(this.messageWindow[message.user.id])
      }

      if(indx == -1){ 
        this.conversations.unshift(this.messageWindow[message.user.id]) 
      }
      
      this.countNotifications()
      })
  }

  getChatUser () {
    return this.chatboxServices.getChatUserById.get({userId: this.Messages.user().id}).$promise.then((dataResult) => {
      if (dataResult.status === true) {
        if(dataResult.data.length == 0){
          console.log("El usuario logueado no posee un rol para utilizar el chat");
          $interval.cancel(this.getCurrentTime)
          $interval.cancel(this.getShowChat)
          $interval.cancel(this.getCurrentUser)
          return
        }
        this.chatUser = dataResult.data
        this.chatUser[0].onLine = 1
        this.updateStatus(true)
        this.getChatContacts()
      } else {
        this.chatUser = []
      }
    }).catch((error) => { 
      console.error(error) 
    })
  }

  getChatContacts () {
    if(this.idRol == 3 || this.idRol == 8 || this.idRol == 9){ 
      var rol = "EVALUATOR" 
    }else if( this.idRol == 13){ 
      var rol = "TEACHER"
    }else{
        return
    }

    let params = {
      userId: this.Messages.user().id,
      rolName: rol
    }

    return this.chatboxServices.getChatContacts.get(params).$promise.then((dataResult) => {
      if (dataResult.status === true) {
        this.chatContacts = dataResult.data.chatContacts.map(chatContact => {
          chatContact.status = chatContact.onLine == 1 ? 'Conectado' : 'Desconectado'
          if (chatContact.userIdentification) {
            chatContact.userPicture = this.getFullpathUserImage(chatContact.userIdentification)
          }
          return chatContact
        })
        this.messageHistory = dataResult.data.messageHistory
        this.receiveData()
      } else {
        this.chatContacts = []
        this.messageHistory = []
      }
      if(dataResult.data.workplan != undefined && dataResult.data.workplan.length > 0){
        this.wp = dataResult.data.workplan[0]
        this.$cookies.put('wp_start', this.wp.dt_startdate);
        this.$cookies.put('wp_end', this.wp.dt_enddate);
      }
    }).catch((error) => { 
      console.error(error) 
    })
  }

  sendMessage (event, to, text) {
    if(!text)return
    if(event.keyCode != 13) return
    var message = {
      from: this.chatUser[0].userPicture,
      to: to,
      data: text,
      user: this.Messages.user(),
      senderId: this.Messages.user().id,
      receiverId: to,
      classChat: 'self',
      dateTime: this.currentTime,
      dateDay: this.checktime(this.currentTime),
      send: 0
    }
    this.messageWindow[to].information.push(message)
    this.messageWindow[to].newComment = ''
    this.messageWindow[to].new = 0

    let post = {
      chatMessage: text,
      receiverUser: to,
      senderUser: this.Messages.user().id
    }

    return this.chatboxServices.addUserMessage.post(post).$promise.then((dataResult) => {
      if (dataResult.status === true) {
        message.send = 1
        message.messageId = dataResult.data.messageId
        this.Messages.send(message)
      } else {
       console.log("Error de servidor PubNub")
      }
    }).catch((error) => { 
      console.error(error) 
    })
  }

  deleteAlertMessage (messageId, idUser) {
    this.idUserDel = idUser
    this.dataMessage = {
      messageId: messageId,
      userId: this.Messages.user().id
    }
    this.messageWindow[idUser].delete = true;
  }

  deleteMessage(bool){
    this.messageWindow[this.idUserDel].delete = false;

    if(!bool) return

    let indx =  this.messageWindow[this.idUserDel].information.findIndex(message=>{
                  return message.messageId === this.dataMessage.messageId
                })

    return this.chatboxServices.updateMessage.post(this.dataMessage).$promise.then((dataResult) => {
      if (dataResult.status === true) {
        this.messageWindow[this.idUserDel].information.splice(indx,1)
        this.succesDeleteMessage()
      } else {
        console.log("Error al eliminar el mensaje");
    }
    }).catch((error) => { 
      console.error(error) 
    })
  }

  succesDeleteMessage(){
    this.messageWindow[this.idUserDel].deleteSuccess = true
    $timeout(() => {
      this.messageWindow[this.idUserDel].deleteSuccess = false
    }, 800);
  }

  closeContacts () {
    this.$rootScope.openContacts = false
  }

  menssages (objeto) {
    return objeto.senderId == this.id || objeto.receiverId == this.id
  }

  updateStatus (value) {
    let post = {
      userId: this.Messages.user().id,
      onLine: value ? 1 : 0
    }
    return this.chatboxServices.updateChatStatus.post(post).$promise.then((dataResult) => {
      if (dataResult.status === true) {
         this.chatUser[0].onLine = post.onLine
      } else {
        console.log("Error al actualizar el estado del usuario")
      }
    }).catch((error) => {
      console.error(error)})
  }

  checktimeHistory (diffTime, time) {
    var dia = ""
     switch (diffTime) {
          case 0:
              dia = "HOY"
              break
          case 1:
              dia = "AYER"
              break
          default: 
              dia = time.split(' ')[0]
        }
    return dia
  }

  checktime(time){
    this.currentTime = moment(this.currentTime).format('YYYY-MM-DD');
    time = moment(time).format('YYYY-MM-DD')
    var dia = ""
    var init = moment(this.currentTime);
    var end = moment(time);
    var diff = init.diff(end, 'days')

   switch (diff) {
          case 0:
              dia = "HOY"
              break
          case 1:
              dia = "AYER"
              break
          default: 
              dia = moment(time).format('DD/MM/YYYY')
        }
    return dia
  }

  filterchat(data){
    return data.new == 1
  }

  countNotifications(){
    this.notifications = this.conversations.filter(filterchat)
    this.$rootScope.chatNotifications = this.notifications.length
  }

  getFullpathUserImage (identification) {
    return this.GlobalConfig.azureProfilePicturePath + identification + '.jpg'
  }


  showMessageWindowChat(data){
    this.messageWindow[data.idUser].showMessageWindow = false;
    this.messageWindow[data.idUser].delete = false;
  }

  minimizeContacs (bool) {
    this.minimizeContact = bool
  }

  newChat (data) {
    if (!this.messageWindow[data.contactUserId]) {
      this.messageWindow[data.contactUserId] = {
        idUser: data.contactUserId, // Consulta completa de contactos
        userFullName: data.userFullName,
        onLine: data.onLine,
        information: [],
        showMessageWindow: true,
        delete: false,
        deleteSuccess: false,
        new: 0
      }

      this.id = data.contactUserId
      this.messageHistoryCreate = this.messageHistory.filter(this.menssages)

      if (this.messageHistoryCreate.length != 0) {
         this.messageHistoryCreate = this.messageHistoryCreate.map(objeto => {
          objeto.from = objeto.senderId != data.contactUserId ? data.userPicture : this.chatUser[0].userPicture
          objeto.classChat = objeto.senderId == data.contactUserId ? 'friend' : 'self'
          objeto.dateDay = this.checktimeHistory(objeto.dateDay, objeto.dateTime)
          objeto.send = 1
          return objeto
        })
        this.messageWindow[data.contactUserId].information = this.messageHistoryCreate
      }
      this.conversations.unshift(this.messageWindow[data.contactUserId])
    } else {
      let i = this.conversations.findIndex(chat => {
        return chat.idUser === data.contactUserId
      })

      if (i >= 3) {
        this.conversations.splice(i, 1)
        this.conversations.unshift(this.messageWindow[data.contactUserId])
      }

      if (i == -1) { this.conversations.unshift(this.messageWindow[data.contactUserId]) }

      this.messageWindow[data.contactUserId].showMessageWindow = true
    }
  }

  minimizeChats (bool) {
    this.showMessageWindow = bool
  }

  closedChat (data) {
    let i = this.conversations.findIndex(chat => {
      return chat.idUser === data.idUser
    })
    this.conversations.splice(i, 1)
  }

  openedChat (data) {
    let i = this.conversations.findIndex(chat => {
      return chat.idUser === data.idUser
    })

    this.conversations.splice(i, 1)
    this.conversations.unshift(this.messageWindow[data.idUser])
  }

  showChatsBoxes (bool) {
  }

  showMessage (data) {
    data.showMessageWindow = true
    data.new = 0
    this.countNotifications()
  }
}

chatboxController.$inject = ['$scope', '$interval', '$timeout', '$cookieStore', '$cookies', '$location', '$filter', '$rootScope', 'chatboxServices', 'Messages', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/chatbox/chatboxController.js